export default "__VITE_ASSET__8ebea6f8__"